var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "STYLES",
    transform: "translate(19.5 18.5) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Menu-Components",
    transform: "translate(1.5 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-26-Copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_x2F_Social_x2F_linked-in--Copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x30_03-linkedin"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    width: 4.05,
    height: 12.375,
    transform: "translate(0 5.625)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M15.837,5.612h-.225c-.225,0-.45-.113-.675-.113a5.33,5.33,0,0,0-4.275,2.363V5.5H6.5V17.875h4.05v-6.75S13.587,6.85,14.825,10v7.875h4.05V9.55A3.99,3.99,0,0,0,15.837,5.612Z",
    transform: "translate(-0.875 0.125)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 2.025,
    cy: 2.025,
    r: 2.025
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.51f59288cbd28ad46ee0d48fc2ed5067.svg";
export { ForwardRef as ReactComponent };